/* eslint-disable react/prop-types */
import React from "react";
import {
  Dialog,
  DialogContent,
  makeStyles,
  Box,
  Button,
  Typography,
  withStyles,
  useMediaQuery,
} from "@material-ui/core";
import { FiLogOut, FiBookOpen } from "react-icons/fi";
import { useHistory, Link } from "react-router-dom";
import { useSelector } from "react-redux";

const useStyles = makeStyles(() => ({
  dialogContent: {
    width: "100%",
    height: "100%",
    flexDirection: "column",
    display: "block",
    backgroundColor: "#FAFAFA",
    boxshadow: "0px 1px 4px rgba(0, 0, 0, 0.2)",
  },
  dialogRoot: {
    maxWidth: "266px",
    borderRadius: 0,
  },
  menuContainer: {
    display: "flex",
    flexDirection: "column",
  },
  textUserMenu: {
    textTransform: "none",
    paddingLeft: "5px",
    fontSize: "14px",
    color: "#5A5A5A",
  },
  textUser: {
    fontSize: "12px",
    paddingLeft: "5px",
    paddingBottom: "10px",
    color: "#A7A7A7",
  },
  textTenant: {
    paddingLeft: "5px",
    fontSize: "14px",
    color: "#A7A7A7",
  },
  borderBarTop: {
    borderTop: "1px solid #e2e2e2",
  },
  buttonUserMenu: {
    // width: "266px",
    textDecoration: "none",
    justifyContent: "start",
    "&:hover": {
      backgroundColor: "#666A8B",
      "& $textUserMenu": {
        color: "white",
      },
      "& $userMenuIcon": {
        color: "white",
      },
    },
  },
  navIcon: {
    color: "inherit",
    marginTop: "0px",
  },
  userMenuIcon: {
    width: "16px",
    height: "16px",
    color: "#909CA9",
  },
  genericRow: {
    display: "flex",
    flexDirection: "row",
    padding: "2px 10px 2px 10px",
  },
  dialogPositon: {
    display: "flex",
    alignItems: "flex-start",
    flexDirection: "column-reverse",
    marginLeft: "40px",
    justifyContent: "end",
  },
  dialogPositonSmall: {
    display: "flex",
    flexDirection: "column-reverse",
    justifyContent: "end",
  },
}));

const ProfileDialogComponent = ({ open = false, handleClose }) => {
  const classes = useStyles();
  const history = useHistory();
  const authSlice = useSelector((state) => state.auth);
  const isSmallScreen = useMediaQuery((theme) => theme.breakpoints.down("md"));

  const handleSignOut = () => history.push({ pathname: "/logout" });

  const StyledDialogContent = withStyles(() => ({
    root: {
      padding: "0px",
      "&:first-child": {
        paddingTop: "10px",
      },
    },
  }))(DialogContent);

  const StyledButton = withStyles(() => ({
    root: {
      padding: "0px",
      paddingLeft: "15px",
      paddingTop: "10px",
      paddingBottom: "10px",
      borderRadius: 0,
    },
  }))(Button);

  return (
    <Dialog
      open={open}
      onBackdropClick={() => handleClose()}
      fullWidth
      maxWidth="md"
      disableRestoreFocus
      classes={{
        scrollPaper: isSmallScreen
          ? classes.dialogPositonSmall
          : classes.dialogPositon,
        paperWidthMd: classes.dialogRoot,
      }}
    >
      <StyledDialogContent className={classes.dialogContent}>
        <Box className={classes.menuContainer}>
          <Box className={classes.genericRow}>
            <Typography variant="body2" className={classes.textTenant}>
              {authSlice.tenant?.company?.name} -{" "}
              {authSlice.tenant?.mysql_database}
            </Typography>
          </Box>
          <Box className={classes.genericRow}>
            <Typography variant="body2" className={classes.textUser}>
              {authSlice.user?.username}
            </Typography>
          </Box>
          <Link
            to={{ pathname: "https://wiseathena.com/knowledgebase" }}
            target="_blank"
            className={`${classes.buttonUserMenu} ${classes.navIcon}`}
            onClick={() => handleClose()}
          >
            <StyledButton
              data-testid="linkToUserGuideButton"
              aria-label="User Guide"
              size="small"
              disableRipple
            >
              <FiBookOpen
                data-testid="FiBookOpen"
                className={`${classes.userMenuIcon} ${classes.navIcon}`}
              />
              <Typography variant="body2" className={classes.textUserMenu}>
                User Guide
              </Typography>
            </StyledButton>
          </Link>
          <div className={classes.borderBarTop} />
          <StyledButton
            data-testid="signOutButton"
            aria-label="Sign Out"
            size="small"
            disableRipple
            className={`${classes.buttonUserMenu}`}
            onClick={handleSignOut}
          >
            <FiLogOut
              className={`${classes.userMenuIcon} ${classes.navIcon}`}
              data-testid="filogout"
            />
            <Typography variant="body2" className={classes.textUserMenu}>
              Logout
            </Typography>
          </StyledButton>
        </Box>
      </StyledDialogContent>
    </Dialog>
  );
};

export default ProfileDialogComponent;
